import React, { FC, ReactElement } from "react";

import {
  Checkbox,
  Grid,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";

import fileTypes from "../../data/fileType";
import { IMAGE, PDF } from "../../data/constants";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  addSharedFiles,
  getSharedDocuments,
  getType,
} from "../../redux/slices/typeSlice";
import {
  getSelectedIndexes,
  updateIndexes,
} from "../../redux/slices/conversationSlice";

import CoPresentIcon from "@mui/icons-material/CoPresent";
import { DeleteOutline } from "@mui/icons-material";

import { DELETE_SHARED_DOCUMENT, GET_DOCUMENT_OWNER } from "../../endpoint";
import apiCall from "../../utils/apiCall";
import {
  getloadingforsharedDocs,
  loadingforindexes,
  loadingforSharedDocs,
} from "../../redux/slices/loadingSlice";
import { addError } from "../../redux/slices/errorSlice";
import { GET_IMAGES_OWNER, DELETE_SHARED_IMAGES } from "../../endpoint";

interface i_listOption {
  checkboxcondition: boolean;
  type: string;
  fileType: string;
  title?: string;
  onClick: (file: string) => void;
}

const SharedDoc: FC<i_listOption> = ({
  checkboxcondition,
  type,
  fileType,
  title,
  onClick,
}): ReactElement => {
  const chatType = useAppSelector(getType);
  const selectedIndexes = useAppSelector(getSelectedIndexes);

  const dispatch = useAppDispatch();

  const includeIndexes = (e: any, index: string) => {
    e?.stopPropagation();
    if (chatType.type === PDF || chatType.type === IMAGE) {
      if (e.target.checked) {
        dispatch(updateIndexes([...selectedIndexes, index]));
      } else {
        dispatch(updateIndexes(selectedIndexes.filter((e) => e !== index)));
      }
    } else {
      if (e.target.checked) {
        dispatch(updateIndexes([index]));
      } else {
        dispatch(updateIndexes([]));
      }
    }
  };

  // const deleteIndex = (index: string) => {
  //   dispatch(loadingforSharedDocs(true));
  //   apiCall("POST", DELETE_SHARED_DOCUMENT, {
  //     index_name: index,
  //   })
  //     .then((res) => {
  //       dispatch(addSharedFiles(res.result));
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         addError("Failed to delete the shared documents.Please try again.")
  //       );
  //     })
  //     .finally(() => {
  //       dispatch(loadingforindexes(false));
  //     });
  // };

  const deleteIndex = (index: string) => {
    dispatch(loadingforSharedDocs(true));
    if (chatType.type === PDF) {
      apiCall("POST", DELETE_SHARED_DOCUMENT, {
        index_name: index,
      }).then((res) => {
        if (res.result === undefined) {
          dispatch(addError("Something wrong while deleting shared docs"));
          dispatch(loadingforindexes(false));
          dispatch(loadingforSharedDocs(false));
        } else {
          dispatch(addSharedFiles(res.result));
          dispatch(loadingforindexes(false));
          dispatch(loadingforSharedDocs(false));
        }
      });
    } else if (chatType.type === IMAGE) {
      apiCall("POST", DELETE_SHARED_IMAGES, {
        image_name: index,
      }).then((res) => {
        if (res.result === undefined) {
          dispatch(addError("Something wrong while deleting shared images"));
          dispatch(loadingforindexes(false));
          dispatch(loadingforSharedDocs(false));
        } else {
          dispatch(addSharedFiles(res.result));
          dispatch(loadingforindexes(false));
          dispatch(loadingforSharedDocs(false));
        }
      });
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & SVGSVGElement) | null
  >(null);

  const [sharedBy, setSharedBy] = React.useState("");

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover1" : undefined;

  // const handleClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
  //   setAnchorEl(event.currentTarget);
  //   apiCall("POST", GET_DOCUMENT_OWNER, {
  //     document_name: type,
  //   })
  //     .then((res) => {
  //       setSharedBy(res.result);
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         addError(
  //           "Failed to load the document owner email Id.Please try again"
  //         )
  //       );
  //     });
  // };

  const handleClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    if (chatType.type === PDF) {
      apiCall("POST", GET_DOCUMENT_OWNER, {
        document_name: type,
      })
        .then((res) => {
          setSharedBy(res.result);
        })
        .catch((err) => console.log(err));
    } else if (chatType.type === IMAGE) {
      apiCall("POST", GET_IMAGES_OWNER, {
        image_name: type,
      })
        .then((res) => {
          setSharedBy(res.result);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //   const whoShared = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {};

  return (
    <ListItem disablePadding sx={{ display: "block" }}>
      <ListItemButton
        sx={{
          minHeight: 48,
          justifyContent: "initial",
        }}
      >
        <Checkbox
          defaultChecked
          color="success"
          sx={{
            m: 0,
            p: 0,
            mr: 0.5,
          }}
          size="small"
          checked={checkboxcondition}
          onChange={(e) => includeIndexes(e, type)}
        />
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 0.5,
            justifyContent: "center",
          }}
        >
          <img src={fileTypes[`${fileType}`]} width="20" />
        </ListItemIcon>
        {type.split("---")[0]?.length > 15 ? (
          <Tooltip title={type}>
            <ListItemText
              primary={type.split("---")[0].substring(0, 13) + "..."}
              sx={{
                opacity: 1,
              }}
              onClick={() => onClick(type)}
              aria-label={type.split("---")[0]}
            />
          </Tooltip>
        ) : (
          <ListItemText
            primary={type.split("---")[0]}
            sx={{
              opacity: 1,
            }}
            onClick={() => onClick(type)}
            aria-label={type.split("---")[0]}
          />
        )}
        <Tooltip title="Shared By">
        <CoPresentIcon
          id="copresenticon"
          color="primary"
           
          onClick={handleClick}
          aria-label="copresent share docs"
        />
        </Tooltip>
        <Tooltip title="Delete">
        <DeleteOutline
          id="deleteshared"
          color="primary"
           
          onClick={() => deleteIndex(type)}
          aria-label="delete share docs"
        />
        </Tooltip>
      </ListItemButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        sx={{
          ".MuiPopover-paper": {
            p: 1,
            m: 1,
          },
        }}
      >
        <Typography>Shared by {sharedBy}</Typography>
      </Popover>
    </ListItem>
  );
};

export default SharedDoc;
